import styled, { css } from 'styled-components';

import {
    mediaMixin,
    ModalDialog,
    Spacer,
    Text,
    token,
} from '@zillow/constellation';

export const CenteredSpacer = styled(Spacer)`
    text-align: center;
`;

export const StyledHeading = styled(Text)`
    && {
        display: block;
        font-size: 16px;
        font-weight: 600;
    }
`;

export const StyledModalDialog = styled(ModalDialog)`
    padding: 0px;

    ${mediaMixin('lg', css`
        padding: 40px 16px;
    `)};
`;

export const StyledErrorText = styled(Text)`
    color: ${token('colors.red600')};
    line-height: 18px;
    text-align: center;
`;
